import { t } from '@/utils/i18n'

/**
 * 浏览器标签标题：固定为「深圳市版权公共服务平台」及其多语言对应文案
 * @returns {string}
 */
export function resolveDocumentTitle() {
  return t('header.logoAlt')
}

/**
 * 更新 document.title
 */
export function updateDocumentTitle() {
  document.title = resolveDocumentTitle()
}
